import React from 'react';
import Cognito from '@letsdothis/cognito';

import { useAuthService } from '@/contexts/authService';
import {
  AuthProviderButton,
  PROVIDER,
} from '@letsdothis/lds/lib/experimental/AuthProviderButton';
import { CONTENT_MODE } from '@letsdothis/lds/lib/Button';

import { ButtonLayout } from './ButtonLayout';
import { GoogleButtonParams } from './Types';

const GoogleButton = ({ returnUrl }: GoogleButtonParams): JSX.Element => {
  const authService = useAuthService();
  return (
    <ButtonLayout>
      <AuthProviderButton
        provider={PROVIDER.google}
        contentMode={CONTENT_MODE.fullWidth}
        onClick={() =>
          authService.login({
            provider: Cognito.IdentityProvider.GOOGLE,
            returnUrl,
          })
        }
      >
        Sign in with Google
      </AuthProviderButton>
    </ButtonLayout>
  );
};

export default GoogleButton;
